"use strict";

exports.__esModule = true;
exports.VIEWPORTS = exports.SCREENS = exports.BREAKPOINTS = void 0;
var SCREENS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
}; // https://criticalmass.invisionapp.com/share/SPTQOOKFJC2#/screens/382033906

exports.SCREENS = SCREENS;
var BREAKPOINTS = {
  xs: {
    MIN: 0,
    MAX: 767
  },
  sm: {
    MIN: 768,
    MAX: 1024
  },
  md: {
    MIN: 1025,
    MAX: 1599
  },
  xl: {
    MIN: 1600,
    MAX: null
  }
}; // Alias

exports.BREAKPOINTS = BREAKPOINTS;
BREAKPOINTS[SCREENS.MOBILE] = BREAKPOINTS.xs;
BREAKPOINTS[SCREENS.TABLET] = BREAKPOINTS.sm;
BREAKPOINTS[SCREENS.DESKTOP] = BREAKPOINTS.md;
var VIEWPORTS = {
  mobile: {
    height: '568px',
    width: BREAKPOINTS.xs.MAX + "px"
  },
  tablet: {
    height: '1112px',
    width: BREAKPOINTS.sm.MAX + "px"
  },
  desktop: {
    height: '1200px',
    width: BREAKPOINTS.md.MAX + "px"
  }
};
exports.VIEWPORTS = VIEWPORTS;